import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => (
  <section id="depoimentos" className="border-y border-gold-400/10 bg-navy-900/40">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 text-center"
      >
        <p className="mb-3 font-mono-tech text-xs tracking-[0.3em] text-gold-400">
          04 — HISTÓRIAS DE APROVAÇÃO
        </p>
        <h2 className="font-serif-display mx-auto max-w-2xl text-3xl font-normal leading-tight tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
          Carimbos que viraram <em className="gold-text italic">memórias.</em>
        </h2>
        <p className="mt-4 font-mono-tech text-[10px] tracking-[0.25em] text-slate-500">
          DEPOIMENTOS ILUSTRATIVOS — SERÃO SUBSTITUÍDOS PELAS AVALIAÇÕES REAIS DOS CLIENTES
        </p>
      </motion.div>

      <div className="grid gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.author}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="card-rim relative rounded-xl border border-gold-400/20 bg-navy-800/70 p-7"
          >
            <Quote className="absolute right-6 top-6 h-8 w-8 text-gold-400/20" />
            <div className="mb-4 flex gap-1">
              {Array.from({ length: t.rating }).map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-gold-400 text-gold-400" />
              ))}
            </div>
            <blockquote className="text-sm font-light leading-relaxed text-slate-300">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-6 border-t border-gold-400/15 pt-4">
              <p className="font-serif-display text-lg text-slate-100">{t.author}</p>
              <p className="mt-1 font-mono-tech text-[10px] tracking-widest text-gold-300">
                {t.destination.toUpperCase()} • {t.city.toUpperCase()}
              </p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
